export const EMPTY_WAGON_QUANTITY = 992200;
export { COLUMNS } from './columns';
